import { inject, Injectable, Optional } from '@angular/core';
import { DatasourceTableJobHttpModel, DatasourceTableJobService } from '@y42/datasource';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42RouterService, Y42Routes } from '@y42/feature/routing';
import { GitQuery } from '@y42/git';
import { AbstractJobCancelationService, JobContextService, JobHttpService, JobTriggerService } from '@y42/job';
import { OrgQuery } from '@y42/org/state';
import { Y42FeatureType } from '@y42/json-schema';
import { IntegrationTableStore } from '../../state/datasource-table';
import { IntegrationTableJobQuery, IntegrationTableJobStore } from '../../state/datasource-table-job';
import { IntegrationStoreQuery } from '../../state/datasource/integration.store-query';

@Injectable({ providedIn: 'root' })
export class IntegrationTableJobService extends DatasourceTableJobService {
  constructor(
    triggerService: JobTriggerService,
    parentStore: IntegrationTableStore,
    jobStore: IntegrationTableJobStore,
    jobQuery: IntegrationTableJobQuery,
    jobContext: JobContextService,
    gitQuery: GitQuery,
    errorHandlerService: ErrorHandlerService,
    jobHttpService: JobHttpService<DatasourceTableJobHttpModel>,
    orgQuery: OrgQuery,
    @Optional() jobCancelationService?: AbstractJobCancelationService,
  ) {
    super(
      triggerService,
      parentStore,
      jobStore,
      jobQuery,
      jobContext,
      gitQuery,
      errorHandlerService,
      jobHttpService,
      getY42GitPath(Y42GitFolders.Integration),
      Y42Routes.Integration,
      inject(Y42RouterService),
      inject(IntegrationStoreQuery).selectLoading(),
      inject(IntegrationStoreQuery).selectActiveId(),
      jobCancelationService,
    );
  }

  readonly defaultFeatureGitPath = getY42GitPath(Y42GitFolders.Integration);
  readonly featureType = Y42FeatureType.Integration;
}
